import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import axios from "axios";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { var_api } from "../../../constant";
import { useNavigate } from "react-router-dom";
const WarehouseTransactionMaster = () => {
  const tableHeaders = [
    "#",
   
    "Product",
    "Variant",
    "Qty",
    "Unit Cost",
    "Total",
   
    "Remarks",
    "Action",
  ];

  const [data, setData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
  const navigate = useNavigate();
  const [transactionDetails, setTransactionDetails] = useState({});
  const    transaction_id = localStorage.getItem("transaction_id");

  const [formData, setFormData] = useState({
    id: null,
    warehouse_id: 1,
    trxn_id: localStorage.getItem("transaction_id"),
    product_id: "",
    variant_id: "",
    qty: "",
    unit_cost: "",
    total: "",
    remarks: "",
   
  });

  // Fetch initial data
  useEffect(() => {
    fetchData();
    fetchProductData();
    fetchVariantData();
     const details = {
      transaction_id: localStorage.getItem("transaction_id"),
      warehouse_id: localStorage.getItem("warehouse_id"),
      trxn_date: localStorage.getItem("trxn_date"),
      trxn_type: localStorage.getItem("trxn_type"),
      reference_number: localStorage.getItem("reference_number"),
      remarks: localStorage.getItem("remarks"),
      created_by: localStorage.getItem("created_by"),
    };
    setTransactionDetails(details);
  }, []);
const getLabel = (options, value) => {
    const found = options.find((o) => String(o.value) === String(value));
    return found ? found.label : "-";
  };

  const trxnTypeOptions = [
    { value: 1, label: "IN" },
    { value: 2, label: "INSTORE-OUT" },
    { value: 3, label: "APPSTORE-OUT" },
    { value: 4, label: "WASTAGE" },
    { value: 5, label: "ADJUSTMENT" },
  ];

  const referenceNumberOptions = [
    { value: 1, label: "GRN" },
    { value: 2, label: "INSTORE SALE" },
    { value: 3, label: "APPSTORE SALE" },
    { value: 4, label: "DAMAGE" },
    { value: 5, label: "ADJUST" },
  ];


 const fetchData = async () => {
  const trxn_id = localStorage.getItem("transaction_id");

  try {
    setInitialLoading(true);
    const res = await axios.get(`${var_api}veemart_warehouse_inventory_transaction_details/getByTrxnId/${trxn_id}`);

    // Ensure `data` is always an array
    const result =
      Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

    setData(result);
  } catch (err) {
    console.error("Error fetching transaction data:", err);
    toast.error("Failed to fetch data");
    setData([]); // fallback to prevent crash
  } finally {
    setInitialLoading(false);
  }
};


  const fetchProductData = async () => {
    const catId = localStorage.getItem("cat_id");
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];
      setProductData(allProducts);
    } catch (err) {
      console.error("Error fetching products:", err);
      toast.error("Failed to fetch product data");
    }
  };

const [allVariantData, setAllVariantData] = useState([]);

const fetchVariantData = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
    const allData = res.data || [];
    setAllVariantData(allData); // store all variants
    setVariantData(allData); // default show all
  } catch (err) {
    toast.error("Failed to fetch variant data");
  }
};

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

 const handleSelectChange = (selected, name) => {
  const value = selected ? selected.value : "";

  setFormData((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: "" }));

  // When product changes, filter variant list
  if (name === "product_id") {
    const filteredVariants = allVariantData.filter(
      (v) => String(v.product_id) === String(value)
    );
    setVariantData(filteredVariants);
    setFormData((prev) => ({ ...prev, variant_id: "" })); // reset variant
  }
};


  const handleAdd = () => {
    setFormData({
       id: null,
    warehouse_id: 1,
    trxn_id: localStorage.getItem("transaction_id"),
    product_id: "",
    variant_id: "",
    qty: "",
    unit_cost: "",
    total: "",
    remarks: "",
    });
    setIsEditMode(false);
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setFormData({ ...item });
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_id) newErrors.product_id = "Product is required";
    if (!formData.variant_id) newErrors.variant_id = "Variant is required";
    if (!formData.qty) newErrors.qty = "Quantity is required";
    if (!formData.unit_cost) newErrors.unit_cost = "Unit Price is required";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.warning("Please fix the highlighted fields");
      return;
    }

    try {
      setLoading(true);
      let res;
      if (isEditMode) {
        res = await axios.put(
          `${var_api}veemart_warehouse_inventory_transaction_details/update/${formData.id}`,
          formData
        );
      } else {
        res = await axios.post(`${var_api}veemart_warehouse_inventory_transaction_details/post`, formData);
      }
      toast.success(res?.data?.message || "Saved successfully");
      setShowModal(false);
      fetchData();
    } catch (err) {
      toast.error("Failed to save record");
    } finally {
      setLoading(false);
    }
  };
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
 
// Filter & Pagination
 const filteredData = data.filter((item) => {
  const productName =
    productData.find((p) => String(p.id) === String(item.product_id))
      ?.product_name || "";

  const variantName =
    allVariantData.find((v) => String(v.id) === String(item.variant_id))
      ?.variant_name || "";

  // Combine all searchable text
  const searchContent = `
    ${productName}
    ${variantName}
    ${item.qty}
    ${item.unit_cost}
    ${item.total}
    ${item.remarks}
  `.toLowerCase();

  return searchContent.includes(searchQuery.toLowerCase());
});

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      <Card>
        <Card.Body>
    <Card className="p-3 mb-3 position-relative">
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h5 className="mb-0">Warehouse Transaction Details</h5>

    {/* 🔙 Back Button */}
    <Button
      variant="outline-primary"
      size="sm"
      onClick={() => navigate("/inventory-transaction")}
    >
      <i className="fas fa-arrow-left me-2"></i> Back to Transactions
    </Button>
  </div>

  <Row className="g-3">
   

    <Col xs="auto">
      <strong>Transaction Date:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {formatDate(transactionDetails.trxn_date)}
      </span>
    </Col>

    <Col xs="auto">
      <strong>Transaction Type:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {getLabel(trxnTypeOptions, transactionDetails.trxn_type)}
      </span>
    </Col>

    <Col xs="auto">
      <strong>Reference Number:</strong>{" "}
      <span style={{ color: "green", fontWeight: "600" }}>
        {getLabel(referenceNumberOptions, transactionDetails.reference_number)}
      </span>
    </Col>

  

  
  </Row>
</Card>

          {initialLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <Button variant="secondary" onClick={handleAdd}>Add</Button>
              </div>

              <div className="table-responsive">
                <table className="table ">
                  <thead>
                    <tr>
                      {tableHeaders.map((h, i) => (
                        <th key={i}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr>
                        <td colSpan="14" className="text-center text-muted py-3">
                          No records found
                        </td>
                      </tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                         <td>
  {
    productData.find((p) => String(p.id) === String(item.product_id))
      ?.product_name || "-"
  }
</td>
<td>
  {
    allVariantData.find((v) => String(v.id) === String(item.variant_id))
      ?.variant_name || "-"
  }
</td>

                          <td>{item.qty}</td>
                          <td>{item.unit_cost}</td>
                          <td>{item.total}</td>
                         
                          <td>{item.remarks}</td>
                          <td>
                             <button
                                className="btn shadow btn-xs sharp"
                                style={{ backgroundColor: "#007bff", color: "white" }}
                                onClick={() => handleEdit(item)}
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                <div className="d-flex justify-content-end">
                  {[...Array(totalPages)].map((_, idx) => (
                    <Button
                      key={idx}
                      variant={currentPage === idx + 1 ? "primary" : "light"}
                      className="me-1"
                      onClick={() => setCurrentPage(idx + 1)}
                    >
                      {idx + 1}
                    </Button>
                  ))}
                </div>
              </div>
            </>
          )}
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditMode ? "Edit Warehouse Transaction" : "Add Warehouse Transaction"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Row>
           

             

              {/* Product Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Product <span className="text-danger">*</span></Form.Label>
                  <Select
                    options={productData.map((p) => ({
                      label: p.product_name,
                      value: p.id,
                    }))}
                    value={
                      formData.product_id
                        ? {
                            label:
                              productData.find(
                                (p) => p.id === formData.product_id
                              )?.product_name || "Select Product",
                            value: formData.product_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "product_id")
                    }
                  />
                  {errors.product_id && (
                    <div className="text-danger small mt-1">{errors.product_id}</div>
                  )}
                </Form.Group>
              </Col>

              {/* Variant Dropdown */}
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Variant <span className="text-danger">*</span></Form.Label>
                  <Select
                    options={variantData.map((v) => ({
                      label: v.variant_name,
                      value: v.id,
                    }))}
                    value={
                      formData.variant_id
                        ? {
                            label:
                              variantData.find(
                                (v) => v.id === formData.variant_id
                              )?.variant_name || "Select Variant",
                            value: formData.variant_id,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleSelectChange(selected, "variant_id")
                    }
                  />
                  {errors.variant_id && (
                    <div className="text-danger small mt-1">{errors.variant_id}</div>
                  )}
                </Form.Group>
              </Col>

              {/* Remaining fields */}
     {/* Quantity */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Quantity <span className="text-danger">*</span></Form.Label>
    <Form.Control
      type="number"
      name="qty"
      placeholder="Enter quantity"
      value={formData.qty}
      onChange={(e) => {
        const value = e.target.value;
        const total = value * (formData.unit_cost || 0);
        setFormData((prev) => ({ ...prev, qty: value, total }));
        setErrors((prev) => ({ ...prev, qty: "" })); // 👈 clear error while typing
      }}
    />
    {errors.qty && <div className="text-danger small mt-1">{errors.qty}</div>}
  </Form.Group>
</Col>

{/* Unit Cost */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Unit Cost <span className="text-danger">*</span></Form.Label>
    <Form.Control
      type="number"
      name="unit_cost"
      placeholder="Enter unit cost"
      value={formData.unit_cost}
      onChange={(e) => {
        const value = e.target.value;
        const total = (formData.qty || 0) * value;
        setFormData((prev) => ({ ...prev, unit_cost: value, total }));
        setErrors((prev) => ({ ...prev, unit_cost: "" })); // 👈 clear error while typing
      }}
    />
    {errors.unit_cost && (
      <div className="text-danger small mt-1">{errors.unit_cost}</div>
    )}
  </Form.Group>
</Col>


{/* Total (Auto-calculated) */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Total</Form.Label>
    <Form.Control
      type="number"
      name="total"
      placeholder="Auto-calculated"
      value={formData.total}
      readOnly
    />
  </Form.Group>
</Col>

{/* Remarks */}
<Col md={6}>
  <Form.Group className="mb-3">
    <Form.Label>Remarks</Form.Label>
    <Form.Control
      as="textarea"
      rows={2}
      name="remarks"
      placeholder="Enter remarks "
      value={formData.remarks}
      onChange={handleInputChange}
    />
  </Form.Group>
</Col>

            </Row>

                       <div className="d-flex justify-content-end gap-2">
                   {!isEditMode ? (
                     <>
                       <Button variant="secondary" type="submit" disabled={loading}>
                         {loading ? (
                           <>
                             <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                             Creating...
                           </>
                         ) : (
                           "Create"
                         )}
                       </Button>
                       <Button
                         variant="danger"
                         type="reset"
                         disabled={loading}
                       onClick={() =>
                   setFormData({
                   id: null,
    warehouse_id: 1,
    trxn_id: localStorage.getItem("transaction_id"),
    product_id: "",
    variant_id: "",
    qty: "",
    unit_cost: "",
    total: "",
    remarks: "",
                   })
                 }
                 
                       >
                         Reset
                       </Button>
                     </>
                   ) : (
                     <>
                       <Button variant="warning" type="submit" disabled={loading}>
                         {loading ? (
                           <>
                             <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                             Updating...
                           </>
                         ) : (
                           "Update"
                         )}
                       </Button>
                       <Button variant="danger" onClick={() => setShowModal(false)} disabled={loading}>
                         Cancel
                       </Button>
                     </>
                   )}
                 </div>
          </Form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default WarehouseTransactionMaster;
